// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu1/Item.css
// module id = 2027
// module chunks = 0